var map = {
	"./tarot-card-0.jpg": 138,
	"./tarot-card-1.jpg": 139,
	"./tarot-card-10.jpg": 140,
	"./tarot-card-11.jpg": 141,
	"./tarot-card-12.jpg": 1341,
	"./tarot-card-13.jpg": 1342,
	"./tarot-card-14.jpg": 1343,
	"./tarot-card-2.jpg": 142,
	"./tarot-card-3.jpg": 143,
	"./tarot-card-4.jpg": 144,
	"./tarot-card-5.jpg": 145,
	"./tarot-card-6.jpg": 146,
	"./tarot-card-7.jpg": 147,
	"./tarot-card-8.jpg": 148,
	"./tarot-card-9.jpg": 149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards ^\.\/tarot\-card\-.*\.jpg$
// module id = 51
// module chunks = 0